export default __webpack_public_path__ + "static/media/egg2.dcffc4f2.jpg";